import dayjs from 'dayjs';

export const opTime = (): dayjs.Dayjs => {
  return dayjs();
};
